/**
 * @package
 */
export const themeBorderWidth = {
  DEFAULT: '2px',
  thin: '1px',
  0: '0px'
} as const;
